export default class RealizationsController {
  /** @ngInject */
  constructor(
    $log, $state
  ) {
    this.$log = $log;
    this.$state = $state;

    this.currentStateName = this.$state.current.name;
  }
}
